import { render, staticRenderFns } from "./UserEntity.vue?vue&type=template&id=2bb40b1e&"
import script from "./UserEntity.vue?vue&type=script&lang=js&"
export * from "./UserEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports